// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function Hero() {
  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  const handlePhoneClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/3c72b2e13a5cec7c6bae92d2bf31a3d5.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center text-center">
          <div className="w-full max-w-4xl">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              JB PINTURAS EM SÃO JOSÉ DOS CAMPOS
            </h1>
            <h2 className="text-2xl lg:text-4xl font-semibold text-orange-300 mb-8">
              Transformando Ambientes com Qualidade e Profissionalismo
            </h2>

            <div className="flex flex-wrap items-center justify-center gap-6 mb-8">
              <div className="flex items-center space-x-2 text-white">
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <span className="font-medium">Mais de 20 Anos</span>
              </div>
              <div className="flex items-center space-x-2 text-white">
                <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <span className="font-medium">Garantia Total</span>
              </div>
              <div className="flex items-center space-x-2 text-white">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-lg"></i>
                </div>
                <span className="font-medium">Equipe Especializada</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <a
                href="https://wa.me/5512981564801"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleWhatsAppClick}
                className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap shadow-xl cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>Orçamento Grátis pelo WhatsApp</span>
              </a>
              <a
                href="tel:+5512981564801"
                onClick={handlePhoneClick}
                className="w-full sm:w-auto bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap shadow-xl cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>Ligue Agora</span>
              </a>
            </div>

            <div className="flex items-center justify-center space-x-3 text-white">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center animate-pulse">
                <i className="ri-whatsapp-line text-2xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xl font-bold">(12) 98156-4801</div>
                <div className="text-sm opacity-90">Clique para falar agora</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
